import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from '../../shared/base/base.component';
import { MatomoTracker } from 'ngx-matomo';
import { ActivatedRoute, Router } from "@angular/router";
import { AppConfigService } from 'src/app/shared/service/app-config.service';
import { LayoutComponent } from 'src/app/layout/layout.component';
@Component({
  selector: 'app-wmsm-Statementabnormal',
  templateUrl: './wmsm-Statementabnormal.component.html',
  styleUrls: ['./wmsm-Statementabnormal.component.scss']
})
export class WmsmStatementabnormalComponent extends BaseComponent implements OnInit {
  loading: boolean = false;
  isShowCondition: boolean = true;
  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;
  nzTotal: number = 0;
  listOfData: any[] = [];
  validateForm: FormGroup;
  formValues: any;
  listOfGoodsData: any;
  isVisible: boolean;

  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private Environment: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private matomotracker: MatomoTracker,
    private ConfigService: AppConfigService,
    private LayoutComponent: LayoutComponent
  ) { super() }

  ngOnInit() {
    this.validateForm = this.fb.group({
      StatementNo: [''],
      PANo: [''],
    });
    this.LayoutComponent.geturl()
    this.matomotracker.trackPageView("供應商管理")
    this.matomotracker.trackEvent("供應商管理", "CN對賬單異常", "Transation", 1);
  }
  getFormValue(value) {
    this.formValues = value;
    if (!this.AuthService.StatementAbnormalData) {

      this.getResultData();
    }
    else {
      this.listOfData = this.AuthService.StatementAbnormalData;
      this.nzTotal = this.AuthService.StatementAbnormalDataTotal;
    }

  }

  getQuery(value) {
    this.isShowCondition = value;
  }
  onSearch() {
    this.isShowCondition = !this.isShowCondition;
    this.getResultData()
  }
  // 获取查询表格数据
  getResultData() {
    this.loading = true;
    const startDate = this.formValues.StatementMonth !== null ? this.formValues.StatementMonth[0] : '';
    const endDate = this.formValues.StatementMonth !== null ? this.formValues.StatementMonth[1] : '';
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetRtStatementAbnormalToDoList.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        Buyer: this.formValues.Buyer,
        Rno: this.formValues.RNO,
        RoleType: sessionStorage.getItem('Whqrole'),
        SiteNo: this.formValues.Site,
        PaNo: this.formValues.PANo,
        AutopaNo: this.formValues.AutoPaNo,
        PoNo: this.formValues.PONO,
        CreateTimeFrom: startDate,
        CreateTimeTo: endDate,
        WithdrawStatus: this.formValues.BillingStatus,
        VendorCode: this.formValues.Vendor
      },
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (
          res &&
          res.status == this.Environment.authConfig.wmsmStatus
        ) {
          this.listOfData = res.data.map((item) => {
            item.statementMonth = this.getTheDateString_YM(item.statementMonth);
            item.acDate = DateUtil.formatYMD(item.acDate);
            return item;
          });
          this.nzTotal = res.total;
          this.AuthService.StatementAbnormalData = this.listOfData;
          this.AuthService.StatementAbnormalDataTotal = res.total;
          this.NzMessageService.success(res.msg);
        } else {
          this.listOfData = [];
          this.nzTotal = 0;
          this.NzMessageService.warning(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error(error.msg);
        this.loading = false;
      }
    );
  }

  //切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();
  }
  //切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }
  RnoOnClick(value) {
    if (value != '') {
      window.open(this.ConfigService.getActualConfig('GotoAutoPaSystemAboutAbnormalURL'), '_blank')
    }
  }


  cancel(): void {

  }

  confirm(data): void {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetInvoiceInfoListDto.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        Rno: data.rNo,
        RoleType: ''//後端會重取
      },
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        this.loading = false;
        this.listOfGoodsData = res.data
      },
      (error) => {
        this.NzMessageService.error(error.msg);
        this.loading = false;
      }
    );
    this.isVisible = true

  }

  handleCancel() {
    this.isVisible = false
  }
  handleOk() {
    this.isVisible = false
  }

  onQueryClick(): string {
    return 'Statementabnormal';
  }

  sortChange(e) {
    this.listOfData = e === 'ascend' ? this.listOfData.sort(
      (a, b) => a.rNo.localeCompare(b.rNo)
    ) : this.listOfData.sort(
      (a, b) => b.rNo.localeCompare(a.rNo)
    )
  }

  exportTableToExecl() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownLoadRtStatementAbnormalExcel.url}`;
    const params = {
      data: {
        Buyer: this.formValues.Buyer,
        SiteNo: this.formValues.Site,
        PaNo: this.formValues.PANo,
        AutoPaNo: this.formValues.AutoPaNo,
        PoNo: this.formValues.PONO,
        Rno: this.formValues.RNO,
        StatementMonthFrom: this.getTheDateString_(this.formValues.StatementMonth[0]),
        StatementMonthTo: this.getTheDateString_(this.formValues.StatementMonth[1]),
        WithdrawStatus: this.formValues.BillingStatus,
        VendorCode: this.formValues.Vendor
      },
    };
    this.WebApiService.doPost(url, params, true).subscribe((res) => {
      this.downloadFile8(res, `CHN_Abnormal_Payment_${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }
}
